let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fmVbI")).then(() => parcelRequire('hNn1a'));